var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row footer"},[_c('div',{staticClass:"col"},[_c('span',[_vm._v(_vm._s(_vm.$t("Footer")))])])])}
var staticRenderFns = []

export { render, staticRenderFns }